<app-site-header />
<section class="content-area-layout1">
    <section class="content-area-layout2">
        <h3>Dealers</h3>
        <p>Optional Search Criteria:</p>
        <form [formGroup]="viewDealersForm">
            <div class="field-container">
                <app-dealer-names-component (messageEvent)="receiveMessage($event)"/>
                <mat-form-field>
                    <mat-label>Contact Last Name</mat-label>
                    <input matInput #input maxlength="50" formControlName="contactLastName"/>
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Contact First Name</mat-label>
                    <input matInput #input maxlength="50" formControlName="contactFirstName"/>
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Email</mat-label>
                    <input matInput #input maxlength="255" formControlName="contactEmail"/>
                </mat-form-field>
            </div>
        </form>
        <section style="padding-top: 1vw; padding-bottom: 1vw;">
            <button style="margin-right: 1vw;" mat-flat-button (click)="listDealers()">Search</button>
            <button style="margin-right: 1vw;" mat-flat-button (click)="resetSearch()">Reset Search</button>
            @if (userHasRole("dealer-editor")) {
            <button mat-flat-button (click)="addDealer()">Add Dealer</button>
            }
        </section>

        <p class="text-aerostar-orange">{{message}}</p>

        @if (dealerCount > 0) {
        <p>Click on row to expand for additional information.</p>
        <div>
            <mat-accordion>
                <section class="mat-elevation-z2 mat-header-row">
                    <span class="mat-header-cell">Dealer ID</span>
                    <span class="mat-header-cell">Dealer Name</span>
                    <span class="mat-header-cell">Country</span>
                    <span class="mat-header-cell">Contact First Name</span>
                    <span class="mat-header-cell">Contact Last Name</span>
                    <span class="mat-header-cell">Email</span>
                    <span class="mat-header-cell">Phone</span>
                    @if (userHasRole("dealer-editor")) {
                    <span class="mat-header-cell">Actions</span>
                    }
                </section>
                <mat-expansion-panel hideToggle *ngFor="let dealer of dealers">
                    <mat-expansion-panel-header class="mat-row">
                        <span class="mat-cell">{{dealer.id}}</span>
                        <span class="mat-cell">{{dealer.name}}</span>
                        <span class="mat-cell">{{dealer.country_code}}</span>
                        <span class="mat-cell">{{dealer.primary_contact_first_name}}</span>
                        <span class="mat-cell">{{dealer.primary_contact_last_name}}</span>
                        <span class="mat-cell">{{dealer.primary_contact_email}}</span>
                        <span class="mat-cell">{{dealer.primary_contact_phone}}</span>
                        @if (userHasRole("dealer-editor")) {
                        <span class="mat-cell">
                            <ng-container matColumnDef="more-vert">
                                <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="View and Update Actions"
                                    (click)=$event.stopPropagation()>
                                    <mat-icon>more_vert</mat-icon>
                                </button>
                                <mat-menu #menu="matMenu">
                                    @if (dealer.status == "A") {
                                    <button mat-menu-item (click)="updateDealer(dealer.id)">
                                        <span>Update Dealer Info</span>
                                    </button>
                                    }
                                    @if (userHasRole("dealer-admin")) {
                                    @if (dealer.status == "A") {
                                    <button mat-menu-item (click)="inactivateDealer(dealer.id)">
                                        <span>Inactivate Dealer</span>
                                    </button>
                                    } @else {
                                    <button mat-menu-item (click)="reactivateDealer(dealer.id)">
                                        <span>Reactivate Dealer</span>
                                    </button>
                                    }
                                    }
                                    @if (isNonProd) {
                                    <button mat-menu-item>
                                        <span (click)="deleteDealer(dealer.id)">Delete Dealer<br><sup>(Limited to
                                                Non-Prod Env)</sup></span>
                                    </button>
                                    }
                                </mat-menu>
                            </ng-container>
                        </span>
                        }
                    </mat-expansion-panel-header>
                    <div>
                        <pre>{{dealer.address_line_1}}<br>{{dealer.address_line_2}}<br>{{dealer.address_line_3}}</pre>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </div>

        <mat-paginator #paginator (page)="handlePageEvent($event)" [length]="dealerCount" [pageSize]="pageSize"
            [disabled]="false" [showFirstLastButtons]="true" [pageSizeOptions]="[5, 10, 25]" [hidePageSize]="false"
            [pageIndex]="pageIndex" aria-label="Select page">
        </mat-paginator>
        }
        @if (dealerCount == 0) {
        <p>No Dealers found</p>
        }
    </section>
</section>